import { forwardRef } from 'react';
/**
 * Creates a functional component that supports the ref prop, and adds the typeRef property needed by axiom findComponent.
 * This function mostly exists to simplify the TS typing when doing this.
 * @param render The render function for the component
 * @param typeRef the typeRef  for the component
 * @returns The forwarded ref version of the component, with the typeRef property added
 */
export default function forwardRefWithAxiomType(render, typeRef) {
  const forwarded = /*#__PURE__*/forwardRef(render);
  forwarded.typeRef = typeRef;
  return forwarded;
}